import { createFileRoute } from "@tanstack/react-router";
import { OAuthConsent } from "@/lib/lazyPages";

export const Route = createFileRoute("/.lovable/oauth/consent")({
  component: OAuthConsent,
});
